@if (item().separator) {
    <hr />
} @else {
    @if (item().visible) {
        @if (hasChildren(item())) {
            <a
                mat-list-item
                class="menu-item"
                [ngStyle]="{ 'padding-left': getPaddingLeft() }"
                (click)="handleMenuClick()"
                (keydown.enter)="handleMenuClick()"
                tabindex="0"
            >
                <mat-icon matListItemIcon>{{ item().icon }}</mat-icon>
                @if (!collapsed()) {
                    <span matListItemTitle>{{ item().label | transloco }}</span>
                }
                <span matListItemMeta>
                    @if (nestedMenuOpen()) {
                        <mat-icon>expand_less</mat-icon>
                    } @else {
                        <mat-icon>expand_more</mat-icon>
                    }
                </span>
            </a>
        } @else {
            <a
                mat-list-item
                class="menu-item"
                [ngStyle]="{ 'padding-left': getPaddingLeft() }"
                [routerLink]="item().route"
                routerLinkActive="selected-menu-item"
                #rla="routerLinkActive"
            >
                <mat-icon matListItemIcon>{{ item().icon }}</mat-icon>
                @if (!collapsed()) {
                    <span matListItemTitle>{{ item().label | transloco }}</span>
                }
                @if (item().endIcon) {
                    <span matListItemMeta>
                        <mat-icon>{{ item().endIcon }}</mat-icon>
                    </span>
                }
            </a>
        }
    }
}

@if (item().children && nestedMenuOpen()) {
    <div @expandContractMenu>
        @for (subItem of item().children; track subItem.label) {
            @if (subItem.visible) {
                @if (subItem.separator) {
                    <div class="sub-menu-item">
                        <hr />
                    </div>
                } @else {
                    <pixl-menu-item [item]="subItem" [subItemCounter]="incSubItemCounter()" />
                }
            }
        }
    </div>
}
